import React from 'react'
import Chip from 'material-ui/Chip'

const PlanHeading = (props) => (
  <div className='flex items-center mt2 flex-column mb2'>
    <div className='mb2'>
      <Chip
        backgroundColor={(props.type === 'free') ? '#4688F1' : '#C347E1'}>
        <div
          style={{fontSize: 12}}
          className='white ttu'>
          {props.plan}
        </div>
      </Chip>
    </div>
  </div>
)

export default PlanHeading



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/PlanHeading.js